import axiosServices from '../utils/axios';

const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const submitWorkspaceActivationRequest = async (payload) => {
  const response = await axiosServices.post(`${backendUrl}/workspace-activation/request`, payload);
  return response.data;
};
